/**
 * These functions can be combined and generate an animation to
 * make the style change back to the previous style smoothly.
 */
import { Style } from "../../../models/style.model";
import leaflet from "leaflet";

const interpolateNumber = (start: number, end: number, ratio: number) => {
  return start + (end - start) * ratio;
};

const interpolateColor = (
  startColor: string,
  endColor: string,
  ratio: number,
) => {
  // Simple interpolation for hex colors
  let startRgb = hexToRgb(startColor);
  let endRgb = hexToRgb(endColor);
  let interpolatedRgb = {
    r: Math.round(interpolateNumber(startRgb.r, endRgb.r, ratio)),
    g: Math.round(interpolateNumber(startRgb.g, endRgb.g, ratio)),
    b: Math.round(interpolateNumber(startRgb.b, endRgb.b, ratio)),
  };
  return rgbToHex(interpolatedRgb.r, interpolatedRgb.g, interpolatedRgb.b);
};

// Convert a hex color to an RGB object
const hexToRgb = (hex: string) => {
  let r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
};

// Convert an RGB object to a hex color
const rgbToHex = (r: number, g: number, b: number) => {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};

// Main function: revert style back to previous one
export const revertStyle = (
  layer: leaflet.Layer,
  clickStyle: Style,
  originalStyle: Style,
  duration: number,
) => {
  const steps = 20; // Number of steps in the transition
  const intervalTime = duration / steps;
  let currentStep = 0;
  const interval = setInterval(() => {
    const ratio = currentStep / steps;
    const interpolatedStyle = {
      color: interpolateColor(clickStyle.color, originalStyle.color, ratio),
      weight: interpolateNumber(clickStyle.weight, originalStyle.weight, ratio),
      opacity: interpolateNumber(
        clickStyle.opacity,
        originalStyle.opacity,
        ratio,
      ),
      fillColor: interpolateColor(
        clickStyle.fillColor,
        originalStyle.fillColor,
        ratio,
      ),
      fillOpacity: interpolateNumber(
        clickStyle.fillOpacity,
        originalStyle.fillOpacity,
        ratio,
      ),
    };
    if (layer instanceof leaflet.Polygon) {
      (layer as leaflet.Polygon).setStyle(interpolatedStyle);
      currentStep++;
      if (currentStep >= steps) {
        clearInterval(interval);
        (layer as leaflet.Polygon).setStyle(originalStyle);
      }
    }
  }, intervalTime);
};
